import React from "react";
import { Link } from "react-router-dom";
import "./LoanScroll.css";

const LoanSection = ({
  sectionNumber,
  label,
  desktopBg,
  mobileBg,
  heading,
  highlight,
  features = [],
  imgSrc,
  imageAlt,
  applyLabel,
}) => {
  const backgroundVariables = {
    "--loan-desktop-bg": `url("${desktopBg}")`,
    "--loan-mobile-bg": `url("${mobileBg}")`,
  };

  const formattedSectionNumber = String(sectionNumber).padStart(2, "0");

  return (
    <article
      className="loan-section"
      style={backgroundVariables}
      id={label.toLowerCase().replaceAll(" ", "-")}
    >
      <div className="loan-section-background" aria-hidden="true"></div>
      <div className="loan-section-overlay" aria-hidden="true"></div>
      <div className="loan-section-grid-pattern" aria-hidden="true"></div>

      <div className="container-fluid loan-section-container">
        <div className="row align-items-center g-4 g-xl-5">
          <div className="col-lg-7">
            <div className="loan-section-content">
              <div className="loan-section-meta">
                <span className="loan-section-number">
                  {formattedSectionNumber}
                </span>

                <span className="loan-section-label">
                  {label}
                </span>
              </div>

              <h2 className="loan-section-title">
                {heading}

                <span className="loan-section-rate">
                  {highlight}
                </span>
              </h2>

              <p className="loan-section-intro">
                Get personalised lender comparison, documentation support
                and complete assistance from Monayra.
              </p>

              <ul className="loan-feature-list">
                {features.map((feature, index) => (
                  <li key={`${label}-${index}`}>
                    <span className="loan-feature-icon">
                      <i className={feature.icon}></i>
                    </span>

                    <span>{feature.text}</span>
                  </li>
                ))}
              </ul>

              <div className="loan-section-actions">
                <Link
                  to="/apply-now"
                  className="loan-primary-button"
                  aria-label={applyLabel}
                >
                  <span>{applyLabel}</span>
                  <i className="bi bi-arrow-right"></i>
                </Link>

                <Link
                  to="/contact"
                  className="loan-secondary-button"
                >
                  <i className="bi bi-headset"></i>
                  Talk to an Expert
                </Link>
              </div>

              <div className="loan-section-trust">
                <div>
                  <i className="bi bi-shield-check"></i>
                  Secure application
                </div>

                <div>
                  <i className="bi bi-door-open"></i>
                  Doorstep assistance
                </div>

                <div>
                  <i className="bi bi-bank"></i>
                  Multiple bank options
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5 d-none d-lg-block">
            <div className="loan-visual-column">
              <div className="loan-visual-orbit loan-orbit-large"></div>
              <div className="loan-visual-orbit loan-orbit-small"></div>

              <div className="loan-visual-card">
                <div className="loan-visual-shine"></div>

                <img
                  src={imgSrc}
                  alt={imageAlt}
                  className="loan-visual-image"
                  loading="lazy"
                />

                <div className="loan-visual-badge">
                  <span className="loan-visual-badge-icon">
                    <i className="bi bi-patch-check-fill"></i>
                  </span>

                  <span>
                    <small>Monayra Assistance</small>
                    <strong>End-to-End Support</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span className="loan-scroll-indicator" aria-hidden="true">
        <span></span>
      </span>
    </article>
  );
};

export default LoanSection;